<template>
  <div class="print-report-container">
    <h3>報表</h3>
    <table class="table">
      <tbody>
        <tr class="table-title">
          <td>產品編號</td>
          <td>下單日期</td>
          <td>收件人</td>
          <td>金牌數量</td>
          <td>金牌總重量(錢)</td>
          <td>黃金收入</td>
          <td>黃金成本</td>
          <td>黃金利潤</td>
          <td>工錢收入</td>
          <td>工錢成本</td>
          <td>工錢利潤</td>
          <td>郵資</td>
        </tr>
        <tr class="table-text" v-for="(reportData,index) in printReportData" :key="index">
          <td>{{ reportData.trade_no }}</td>
          <td>{{ moment(reportData.created_at).format("YYYY-MM-DD")}}</td>
          <td>{{ reportData.full_name }}</td>
          <td>{{ reportData.amount }}</td>
          <td>{{ reportData.weight }}</td>
          <td>{{ reportData.gold_price }}</td>
          <td>{{ reportData.gold_cost }}</td>
          <td>{{ reportData.gold_profit }}</td>
          <td>{{ reportData.fee_price }}</td>
          <td>{{ reportData.fee_cost }}</td>
          <td>{{ reportData.fee_profit }}</td>
          <td>{{ reportData.postal_cost }}</td>
        </tr>
        <tr class="table-total" >
          <td></td>
          <td></td>
          <td>總和</td>
          <td>{{printReportSum.countSum}}</td>
          <td>{{printReportSum.weightSum}}</td>
          <td>{{printReportSum.goldpriceSum}}</td>
          <td>{{printReportSum.goldcostSum}}</td>
          <td>{{printReportSum.goldprofitSum}}</td>
          <td>{{printReportSum.feepriceSum}}</td>
          <td>{{printReportSum.feecostSum}}</td>
          <td>{{printReportSum.feeprofitSum}}</td>
          <td>{{printReportSum.postalcostSum}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "admin_printReport",
  props: {
    printReportData: {
      type: Array
    },
    printReportSum: {
      type: Object
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.print-report-container {
  text-align: center;
  .table {
    width: 90%;
    margin: auto;
  }
  .table-title {
    & > td {
      background-color: $secondaryLightColor1;
      padding: 6px 0;
      border-bottom: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
    }
  }
  .table-text {
    & > td {
      padding: 6px 0;
      border-bottom: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
    }
  }
  .table-total {
    & > td {
      background-color: $secondaryLightColor1;
      padding: 6px 0;
      border-bottom: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
    }
  }
}

@media print {
  * {
    -webkit-print-color-adjust: exact !important;
  }
  .print-report-container {
    page-break-inside: avoid;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
